<template>
  <div class="aiPageBg generateResult">
    <navbar :nav="nav"></navbar>
    <div class="resultContent baseStyle">
      <div class="imgItem">
        <div class="itemsBox">
          <div
            class="items"
            v-if="imgData.firstPicture && imgData.firstPicture != ''"
          >
            <img class="img" :src="imgData.firstPicture" />
            <img class="img" src="../../assets/img/logo.png" />
            <div class="operate">
              <img
                class="icon"
                src="../../assets/img/icon/icon_del.png"
                @click.stop="delImg({ firstPicture: '', id: imgData.id })"
              />
              <img
                @click="
                  downModel(imgData.firstPicture, {
                    firstPicture: imgData.firstPicture
                  })
                "
                class="icon"
                src="../../assets/img/icon/icon_down.png"
              />
            </div>
          </div>
          <div
            class="items"
            v-if="imgData.secondPicture && imgData.secondPicture != ''"
          >
            <img class="img" :src="imgData.secondPicture" />
            <div class="operate">
              <img
                class="icon"
                src="../../assets/img/icon/icon_del.png"
                @click.stop="delImg({ secondPicture: '', id: imgData.id })"
              />
              <img
                @click="
                  downModel(imgData.secondPicture, {
                    secondPicture: imgData.secondPicture
                  })
                "
                class="icon"
                src="../../assets/img/icon/icon_down.png"
              />
            </div>
          </div>
          <div
            class="items"
            v-if="imgData.thirdPicture && imgData.thirdPicture != ''"
          >
            <img class="img" :src="imgData.thirdPicture" />
            <div class="operate">
              <img
                class="icon"
                src="../../assets/img/icon/icon_del.png"
                @click.stop="delImg({ thirdPicture: '', id: imgData.id })"
              />
              <img
                @click="
                  downModel(imgData.thirdPicture, {
                    thirdPicture: imgData.thirdPicture
                  })
                "
                class="icon"
                src="../../assets/img/icon/icon_down.png"
              />
            </div>
          </div>
          <div
            class="items"
            v-if="imgData.fourthPicture && imgData.fourthPicture != ''"
          >
            <img class="img" :src="imgData.fourthPicture" />
            <div class="operate">
              <img
                class="icon"
                src="../../assets/img/icon/icon_del.png"
                @click.stop="delImg({ fourthPicture: '', id: imgData.id })"
              />
              <img
                @click="
                  downModel(imgData.fourthPicture, {
                    fourthPicture: imgData.fourthPicture
                  })
                "
                class="icon"
                src="../../assets/img/icon/icon_down.png"
              />
            </div>
          </div>
        </div>
        <div class="itemsBox" v-if="imgData.loading">
          <div class="items" v-for="(k, i) in 4" :key="i">
            <div
              style="height: 100%; display: flex; align-items: center; justify-content: center;"
            >
              <van-loading type="spinner" color="#fff" />
            </div>
          </div>
        </div>
      </div>
      <div></div>
      <div class="resultTextBox">
        <div class="text">生成文言</div>
        <div class="textMax">
          {{ imgData.inputContent }}
        </div>
        <div class="text last">スタイル</div>
        <div class="tags" v-if="imgData.type">
          <div v-if="imgData.type == '1'">アニメ</div>
          <div v-if="imgData.type == '2'">写真</div>
          <div v-if="imgData.type == '3'">3Dレンダー</div>
          <div v-if="imgData.type == '4'">イラスト</div>
          <div v-if="imgData.type == '5'">アメコミ</div>
          <div v-if="imgData.type == '6'">デジタルアート</div>
          <div v-if="imgData.type == '7'">水彩</div>
          <div v-if="imgData.type == '8'">浮世絵</div>
          <div v-if="imgData.type == '9'">おまかせ</div>
        </div>
      </div>
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="buttonBlue"
        @click="goResult()"
        >もう一度生成</van-button
      >
      <van-popup v-model="goDownPopup" closeable>
        <div class="content">
          <!-- {{ option.fixedNumber }} -->
          <cropper
            ref="cropper"
            :img="option.img"
            :option="option"
            @getbase64Data="getbase64Data"
            :sizeData="sizeData"
          ></cropper>
        </div>
      </van-popup>
      <van-popup v-model="goDelImgPopup">
        <div class="content">
          <div>この画像を削除しますか？</div>
          <!-- <div>全部削除しますか?</div> -->
        </div>
        <div class="buttonItem">
          <div class="button cancel" @click="goDelImgPopup = false">
            キャンセル
          </div>
          <div class="button del" @click="saveDelImg()">削除</div>
        </div>
      </van-popup>
      <van-popup v-model="gohomepopup">
        <div class="content">
          <div>
            生成が完了しました。結果を確認するには、ギャラリー画面へ進んでください。
          </div>
        </div>
        <div class="buttonItem">
          <div
            class="button cancel"
            @click="$router.push({ path: `/` })"
            style="width: 65%;margin-left:auto;margin-right:auto;"
          >
            ギャラリー画面へ
          </div>
        </div>
      </van-popup>
    </div>
    <van-overlay :show="loadingShow" z-index="9990">
      <div class="wrapper">
        <van-loading type="spinner" color="#fff" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import { Overlay } from "vant";

Vue.use(Overlay);
Vue.use(Toast);
// import { VueCropper }  from 'vue-cropper'
// import H5Cropper  from 'vue-cropper-h5'
import cropper from "../chat/cropper.vue";
import navbar from "../../components/navbar/index.vue";
import {
  pictureDetailList,
  tobase64,
  pictureScaleList,
  pictureUpdate,
  memberPackage,
  pictureDownload,
  genImages
} from "@/http/home";
export default {
  components: {
    navbar,
    // H5Cropper,
    cropper
    // VueCropper
  },
  data() {
    return {
      nav: {
        back: true,
        title: "生成結果",
        chat: true
      },
      imgData: {
        loading: true
      },
      goDownPopup: false,
      downData: {},
      shoudong: false,
      checkTag: 0,
      width: "",
      height: "",
      option: {
        // img: "http://site.big-sight.com/ai-web/static/img/img1.d60c566.png",
        img: "",
        fixedNumber: []
      }, //配置
      sizeData: [],
      goDelImgPopup: false,
      loadingShow: false,
      delData: {},
      downImgquery: {},
      imgId: "",
      gohomepopup: false
    };
  },
  mounted() {
    // localStorage.setItem("keyWordsId", 1117);
    this.imgData.loading = true;
    if (this.$route.query.id || localStorage.getItem("imgId")) {
      this.imgId = this.$route.query.id
        ? this.$route.query.id
        : localStorage.getItem("imgId");
      this.getList();
    } else {
      if (localStorage.getItem("message")) {
        this.shengchengImages();
      } else {
        this.gohomepopup = true;
      }
    }
  },
  methods: {
    shengchengImages() {
      let message = localStorage.getItem("message");
      let messageType = localStorage.getItem("messageType");
      let keyWordsId = localStorage.getItem("keyWordsId")
        ? localStorage.getItem("keyWordsId")
        : "";
      let firstMessageContent = localStorage.getItem("firstMessageContent")
        ? localStorage.getItem("firstMessageContent")
        : "";
      this.imgData = {
        inputContent: message,
        type: messageType,
        loading: true
      };
      // this.imgData.inputContent = message
      // this.imgData.type = messageType
      // this.imgData.firstPicture = ''
      // this.imgData.secondPicture = ''
      // this.imgData.thirdPicture = ''
      // this.imgData.fourthPicture = ''
      Toast.loading({
        message: "生成中...",
        duration: 0,
        forbidClick: true
      });
      localStorage.removeItem("message");
      genImages({
        requestMessageContent: message,
        messageType: messageType,
        keyWordsId: keyWordsId,
        firstMessageContent: firstMessageContent
      }).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          localStorage.removeItem("message");
          localStorage.removeItem("messageType");
          localStorage.removeItem("keyWordsId");
          Toast.clear();
          let content = data.responseMessageContent;
          localStorage.setItem("imgId", content);
          this.getList(content);
        } else {
          Toast.clear();
          Toast({
            type: "fail",
            icon: "cross",
            message: res.data.msg
          });
        }
      });
    },
    getList(contentID) {
      let id = this.imgId ? this.imgId : contentID;
      pictureDetailList({ id: id }).then(res => {
        let { data, code } = res.data;
        this.imgData.loading = false;
        if (code == 200) {
          this.imgData = data;
          if (!data) {
            this.$router.push({ path: `/` });
          }
        }
      });
      pictureScaleList().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.sizeData = data;
          let item = this.sizeData[0];
          this.option.fixedNumber = [];
        }
      });
    },
    //下载图片
    getbase64Data(data) {
      this.img = data.data;
      let name = new Date().getTime();
      this.downloadFile(`${name}`, data.data);
      this.option.fixedNumber = [];
      let id = this.$route.query.id;
      let params = {
        id: id,
        pictureScaleId: data.pictureScaleId,
        ...this.downImgquery
      };
      pictureDownload(params).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
        }
      });
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement("a");
      let blob = this.base64ToBlob(content); //new Blob([content]);
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);
      //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      // aLink.dispatchEvent(evt);
      aLink.click();
      this.goDownPopup = false;
      Toast({
        type: "success",
        message: "ダウンロードに成功しました"
      });
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    delImg(query) {
      this.delData = query;
      this.goDelImgPopup = true;
    },
    saveDelImg() {
      //确定删除
      pictureUpdate(this.delData).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.goDelImgPopup = false;
          this.getList();
          Toast({
            type: "success",
            // duration: 0,
            message: "削除しました"
          });
        }
      });
    },
    downModel(url, query) {
      this.loadingShow = true;
      this.downImgquery = query;
      tobase64({ imageUrl: url }).then(res => {
        this.loadingShow = false;
        let { data, code } = res.data;
        if (code == 200) {
          this.option.resetCheckTag = true;
          this.option.autoCropWidth = window.innerWidth > 1439 ? 400 : 250;
          this.option.autoCropHeight = window.innerWidth > 1439 ? 400 : 250;
          this.option.img = "data:image/png;base64," + data;
          this.goDownPopup = true;
        }
      });
    },
    saveDown() {},
    goResult() {
      memberPackage().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          if (!data || data.alreadyGenerateNumber >= data.generateNumber) {
            Toast({
              type: "fail",
              message:
                "本日のコースの生成回数は終了しており、回数を増やしてコースを変更するか、明日再試行する必要があります"
            });
            return;
          } else {
            // this.$router.push({ path: `/` });
            let text = this.imgData.inputContent;
            this.$router.push({
              path: `/generateStyle`,
              query: { text: text }
            });
          }
        }
      });
    }
  }
};
</script>

<style>
/* .wrapper /deep/ .crop-point {
  opacity: 0;
  z-index: 523;
}
.wrapper /deep/ .cropper-view-box {
  outline: 1px solid #fff;
  border: 1px solid #fff;
}
.wrapper /deep/ .vue-cropper {
  background-color: #000;
  background-image: none;
}
.wrapper {
  height: calc(100vh - 21.333vw);
  padding: 4vw;
} */
.resultContent {
  width: calc(100% - 30px);
  padding: 0 15px 15px 15px;
  /* height: calc(100% - 25px); */
  height: calc(100% - 25px);
  height: -webkit-calc(100% - 25px);
  position: relative;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
}
.resultContent .imgItem .operate {
  /* justify-content: flex-end; */
}
.resultContent .resultTextBox {
  width: 100%;
  min-height: 56px;
  border-radius: 12px;
  margin-bottom: 30px;
  padding: 16px;
  line-height: 22px;
  box-sizing: border-box;
  background: #ffffff;

  /* 卡片投影 */
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0);
}
.resultContent .text {
  color: rgb(35, 32, 54, 0.5);
  font-size: 14px;
}
.resultContent .textMax {
  font-size: 16px;
  margin: 8px 0;
  color: rgba(0, 0, 0, 0.9);
}
.resultContent .text.last {
  margin-top: 20px;
}
.resultContent .resultTextBox .tags {
  display: inline-block;
  height: 36px;
  line-height: 36px;
  border-radius: 45px;
  font-size: 14px;
  padding: 0 22px;
  margin-top: 8px;
  color: #2b99ff;
  background: rgba(43, 153, 255, 0.2);
}
.resultContent .sizeLeftBox {
  width: 50%;
}
.resultContent .list {
  width: calc(50% - 8px);
  margin-right: 8px;
  display: inline-block;
  float: left;
}

.resultContent .sizeTags {
  background: #eaf0f6;
  height: 36px;
  line-height: 36px;
  border-radius: 45px;
  padding: 0;
  margin-top: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  cursor: pointer;
}
.resultContent .sizeTags.sizeTagsMax {
  width: 100%;
  justify-content: center;
}
.resultContent .sizeTags.checkTag {
  background: #2b99ff;
}
.resultContent .sizeTags.checkTag .size {
  border: 1.5px solid #ffffff;
}
.resultContent .sizeTags.checkTag .text {
  color: #ffffff;
}
.resultContent .sizeTags .size {
  transform: rotate(90deg);
  border-radius: 2px;
  opacity: 1;
  margin-right: 6px;
  box-sizing: border-box;
  border: 1.5px solid rgba(35, 32, 54, 0.2);
  display: inline-block;
}
.resultContent .sizeTags .size_4_3 {
  width: 14px;
  height: 15px;
}
.resultContent .sizeTags .size_16_9 {
  width: 11px;
  height: 15px;
}
.resultContent .sizeTags .size_3_4 {
  width: 15px;
  height: 14px;
}
.resultContent .sizeTags .size_9_16 {
  width: 15px;
  height: 11px;
}
.resultContent .sizeTags .size_1_1 {
  width: 13px;
  height: 13px;
}
.resultContent .sizeTags .text {
  color: #3d3d3d;
  display: inline-block;
}
.aiCenter .resultContent .van-popup .buttonItem.cropperBtn {
  /* margin-top: 24px; */
  height: 48px;
}

.aiCenter .resultContent .sizeInput {
  border: none;
  font-family: RegularFont;
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.9);
  width: 50px;
  height: 32px;
  line-height: 32px;
  background-color: transparent;
  text-align: center;
}
.aiCenter .resultContent .buttonItem .icon {
  width: 20px;
  height: 18px;
}
.van-popup .btnList {
  /* position: absolute;
  left: 24px;
  bottom: 24px;
  width: calc(100% - 48px);
  z-index: 9; */
  margin-top: 24px;
}
.van-popup .btnList .icon {
  width: 20px;
  height: 18px;
}
.aiPageBg .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
@media screen and (min-width: 1439px) {
  .resultContent {
    width: calc(100% - 30px); /* no*/
    padding: 0 15px 15px 15px; /* no*/
    height: calc(100% - 15px); /* no*/
  }
  .resultContent .resultTextBox {
    width: 100%; /* no*/
    min-height: 56px; /* no*/
    border-radius: 12px; /* no*/
    margin-bottom: 30px; /* no*/
    padding: 16px; /* no*/
    line-height: 22px; /* no*/

    /* 卡片投影 */
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0); /* no*/
  }
  .resultContent .text {
    font-size: 14px; /* no*/
  }
  .resultContent .textMax {
    font-size: 16px; /* no*/
    margin: 8px 0; /* no*/
  }
  .resultContent .text.last {
    margin-top: 20px; /* no*/
  }
  .resultContent .resultTextBox .tags {
    height: 36px; /* no*/
    line-height: 36px; /* no*/
    border-radius: 45px; /* no*/
    font-size: 14px; /* no*/
    padding: 0 22px; /* no*/
    margin-top: 8px; /* no*/
  }
  .resultContent .textMax {
    font-size: 16px; /* no*/
    margin: 8px 0; /* no*/
  }
  .aiCenter .resultContent .sizeInput {
    font-size: 14px; /* no*/
    width: 50px; /* no*/
    height: 32px; /* no*/
    line-height: 32px; /* no*/
  }

  .resultContent .list {
    width: calc(50% - 8px); /* no*/
    margin-right: 8px; /* no*/
  }

  .resultContent .sizeTags {
    height: 36px; /* no*/
    line-height: 36px; /* no*/
    border-radius: 45px; /* no*/
    margin-top: 16px; /* no*/
    width: 100%;
  }

  .resultContent .sizeTags .size {
    border-radius: 2px; /* no*/
    margin-right: 6px; /* no*/
    border: 1.5px solid rgba(35, 32, 54, 0.2); /* no*/
  }

  .resultContent .sizeTags .size_4_3 {
    width: 14px; /* no*/
    height: 15px; /* no*/
  }
  .resultContent .sizeTags .size_16_9 {
    width: 11px; /* no*/
    height: 15px; /* no*/
  }
  .resultContent .sizeTags .size_3_4 {
    width: 15px; /* no*/
    height: 14px; /* no*/
  }
  .resultContent .sizeTags .size_9_16 {
    width: 15px; /* no*/
    height: 11px; /* no*/
  }
  .resultContent .sizeTags .size_1_1 {
    width: 13px; /* no*/
    height: 13px; /* no*/
  }
  .aiCenter .resultContent .van-popup .buttonItem.cropperBtn {
    height: 48px; /* no*/
  }
  .van-popup .btnList {
    margin-top: 24px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/generateResult.vue